// Libraries
import _ from 'lodash';
import React from 'react';

// App
import Switch from '@shared/design/components/Switch';
import {ProjectTypeFeatureFormType} from '@shared/modules/Project/forms/ProjectTypeFeatureForm';

const ProjectTypeValuationCoverageBillingPanelEdit = ({
  form,
  field,
}: {
  form: ProjectTypeFeatureFormType;
  field: string;
}) => {
  const taxValuationCoverageField = `${field}.isEnabled`;
  const isEnabledTaxValuationCoverage = _.get(form.values, taxValuationCoverageField);

  return (
    <Switch
      labelRight={'Tax Valuation Coverage'}
      isOn={isEnabledTaxValuationCoverage}
      onChange={() => form.setFieldValue(taxValuationCoverageField, !isEnabledTaxValuationCoverage)}
    />
  );
};

export default ProjectTypeValuationCoverageBillingPanelEdit;
